import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { HOME_USP_CARDS } from '../../constants/homeLanding';
import DpdOnlineUspIcon from './DpdOnlineUspIcon';

const USP_ICON_VARIANTS = [
  'poundShield',
  'lockers',
  'uniform',
  'price',
  'weight',
  'pin',
  'world',
  '1hr',
];

function HomeUsps() {
  return (
    <Box
      sx={{
        px: { xs: 2, md: '120px' },
        py: { xs: 3, md: 3 },
        backgroundColor: 'background.default',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, minmax(0, 1fr))',
            sm: 'repeat(2, minmax(0, 1fr))',
            md: 'repeat(4, minmax(0, 1fr))',
            lg: 'repeat(8, minmax(0, 1fr))',
          },
          gap: { xs: 1, md: 1 },
        }}
      >
        {HOME_USP_CARDS.map((card, index) => {
          const variant = USP_ICON_VARIANTS[index] || 'poundShield';
          return (
            <Paper
              key={card.textLines.join('-')}
              elevation={1}
              sx={{
                borderRadius: 1,
                backgroundColor: 'primary.pageBackground',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: 0.75, md: 1 },
                  p: { xs: 1.25, md: 2 },
                  minHeight: { xs: 120, md: 'auto' },
                  textAlign: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: { xs: 0.75, md: 1 },
                    borderRadius: '100px',
                    backgroundColor: 'background.paper',
                  }}
                >
                  <DpdOnlineUspIcon variant={variant} />
                </Box>
                <Box>
                  {card.textLines.map(line => (
                    <Typography
                      key={line}
                      sx={{
                        fontFamily:
                          'Pluto Sans DPD, Helvetica, Arial, sans-serif',
                        fontSize: { xs: 12, md: 14 },
                        lineHeight: 1.43,
                        letterSpacing: { xs: 0.12, md: 0.17 },
                        color: 'text.primary',
                        display: 'block',
                      }}
                    >
                      {line}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Paper>
          );
        })}
      </Box>
    </Box>
  );
}

export default HomeUsps;
